// extracted by mini-css-extract-plugin
export default {"smallBorderBoxHeader":"SmallBorderBox_smallBorderBoxHeader__Dm-4h","smallBorderBox":"SmallBorderBox_smallBorderBox__7wld8"};